// extracted by mini-css-extract-plugin
export var editButton = "_mb-0";